module.exports = __webpack_public_path__ + "static/img/fenxi.bab852e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fenxi.png
// module id = p0yr
// module chunks = 0